module.exports = __webpack_public_path__ + "86d64d754289af46b6391557dff1494b.MP3";